
/**
 * Get current profile's avatar
 * @param {*} avatarCollection
 * @param {*} currentProfile
 * 
 * @return {Object}  avatar's data
 */
 export const getAvatarByProfile = (avatarCollection, profileCollection, currentProfile) => {
    const avatarId = getCurrentProfileData(profileCollection, currentProfile)?.props.avatarId;
    return avatarCollection?.find(avatar => avatar.id === avatarId)
}



/**
 * Get current profile's data
 * @param {*} profileCollection 
 * @param {*} currentProfile
 * 
 * @return {Object}  current profile's data
 */
 export const getCurrentProfileData = (profileCollection, currentProfile) => {
    return profileCollection?.find(profile => profile.id === currentProfile);
}
